import { render, staticRenderFns } from "./screening-qr-dialog.vue?vue&type=template&id=bd750878&scoped=true"
import script from "./screening-qr-dialog.vue?vue&type=script&lang=js"
export * from "./screening-qr-dialog.vue?vue&type=script&lang=js"
import style0 from "./screening-qr-dialog.vue?vue&type=style&index=0&id=bd750878&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd750878",
  null
  
)

export default component.exports